// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import ModalController from './modal_controller';
import SearchController from './search_controller';
import SubmitOnKeyupController from './submit_on_keyup_controller';
import ReorderController from './reorder_controller';
import DetailsController from './details_controller';
import SettingsController from './settings_controller';
import LevelFiltersController from './level_filters_controller';
import LinkController from './link_controller';
import DatepickerController from './datepicker_controller';
import TooltipController from './tooltip_controller';
import SquareController from './square_controller';
import SearchFilterController from './search_filter_controller';
import EditTransactionDetailsController from './edit_transaction_detail_controller';
import SubmitOnEventController from './submit_on_event_controller';
import TransactionCollaborationController from './transaction_collaboration_controller';
import FormValidationController from './form_validation_controller';
import ExternalUploadPdfDocumentsController from './external_upload_pdf_documents_controller';
import signature_pad_controller from './signature_pad_controller';
import CollectionSelectController from './collection_select_controller';
import persist_dropdown_controller from './persist_dropdown_controller';
import ContactAutocompleteController from './contact_autocomplete_controller';
import LoadingController from './loading_controller';
import filter_indicator_controller from './filter_indicator_controller';
import EmbeddedPdfViewer from './embeddedPdfViewer';
import drag_drop_upload from './drag_drop_upload';
import select_controller from './select_controller';
import autoscroll_controller from './autoscroll_controller';
import CommissionCardController from './commission_card_controller';
import CommissionPlanController from './commission_plan_controller';
import CommissionPlanFeeController from './commission_plan_fee_controller';
import ApplyCommissionPlanController from './apply_commission_plan_controller';
import SplitDocumentsController from './split_documents_controller';
import TimestampController from './timestamp_controller';
import PhoneMaskController from './phone_mask_controller';
import InputNumberMaskingController from './input_number_masking_controller';
import DeleteConfirmationController from './delete_confirmation_controller';
import DownloadController from './download_controller';
import MoveDocumentController from "./move_document_controller";
import RenameDocumentController from './rename_document';
import EditContactModalController from './edit_contact_modal_controller';

application.register('modal', ModalController);
application.register('search', SearchController);
application.register('submit_on_keyup', SubmitOnKeyupController);
application.register('reorder', ReorderController);
application.register('details', DetailsController);
application.register('settings', SettingsController);
application.register('levelFilters', LevelFiltersController);
application.register('link', LinkController);
application.register('datepicker', DatepickerController);
application.register('tooltip', TooltipController);
application.register('square', SquareController);
application.register(
  'edit_transaction_details',
  EditTransactionDetailsController
);
application.register('submitOnEvent', SubmitOnEventController);
application.register('searchFilter', SearchFilterController);
application.register(
  'transaction-collaboration',
  TransactionCollaborationController
);
application.register('formValidation', FormValidationController);
application.register(
  'externalUploadPdfDocuments',
  ExternalUploadPdfDocumentsController
);
application.register('signature-pad', signature_pad_controller);
application.register('collectionSelect', CollectionSelectController);

application.register('persist_dropdown', persist_dropdown_controller);
application.register('loading', LoadingController);
application.register('filter_indicator', filter_indicator_controller);
application.register('embeddedPdfViewer', EmbeddedPdfViewer);
application.register('drag_drop_upload', drag_drop_upload);
application.register('select', select_controller);
application.register('autoscroll', autoscroll_controller);

application.register('commission_card', CommissionCardController);
application.register('commission-plan-fee', CommissionPlanFeeController);

application.register('apply-commission-plan', ApplyCommissionPlanController);
application.register('commission-plan', CommissionPlanController);

application.register('contactAutocomplete', ContactAutocompleteController);
application.register('split-documents', SplitDocumentsController);
application.register("timestamp", TimestampController);
application.register('PhoneMaskController', PhoneMaskController);
application.register('InputNumberMaskingController', InputNumberMaskingController);

application.register('DeleteConfirmationController', DeleteConfirmationController);
application.register('DownloadController', DownloadController);
application.register("move-document", MoveDocumentController);
application.register("rename-document", RenameDocumentController);
application.register("edit-contact-modal", EditContactModalController);